import { render, staticRenderFns } from "./uv-configurations.vue?vue&type=template&id=5a54cd00&"
import script from "./uv-configurations.vue?vue&type=script&lang=ts&"
export * from "./uv-configurations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports